import Head from "next/head";
import CrystalGambitTablesPage from "../../../../src/tables/s15/CrystalGambit.tsx";

export default function CrystalGambitTablesRoute({ tables }) {
  return (
    <>
      <Head>
        <title>TFT Set 15 Crystal Gambit Tables</title>
      </Head>
      <CrystalGambitTablesPage tables={tables} />
    </>
  );
}

export async function getStaticProps() {
  const tablesResp = await fetch(
    `https://ap.tft.tools/static/s15/gemforce.json`,
  );
  const tables = await tablesResp.json();

  return {
    props: {
      tables,
    },
    revalidate: 3600,
  };
}
